import { CollabItem as Root } from './CollabItem'
import { ReplyForm } from './ReplyForm/ReplyForm'

export const CollabItem = {
  Root,
  ReplyForm,
}
